import { sendAnalyticsInfo } from 'features/analytics/helpers';
import type { CommentType } from 'features/call/call-comments/enums';
import { VrsCallCommentsLogMessages } from 'features/call/vrs-call-comments/enums';

export const closeCallAnalytics = (methodName: string) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: VrsCallCommentsLogMessages.CALL_COMPLETE_INITIATE,
  });
};

export const callCommentsFormSubmitAnalytics = (
  methodName: string,
  commentTypes: CommentType[]
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: VrsCallCommentsLogMessages.VRS_REPORT_SENT_SUCCESS,
    CommentTypes: commentTypes,
  });
};

export const vrsCallCommentsMenuButtonClickAnalytics = (
  methodName: string,
  isReportNeeded: boolean
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Event: {
      originator: 'VrsCallCommentsRegularMenuButton',
      message: 'Toggle Report Button Clicked',
    },
    Message: 'Toggle Report Button Clicked',
    Value: isReportNeeded,
  });
};
